import { ExtraOptions, RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import {NbAuthComponent} from '@nebular/auth';
import { LoginComponent } from './auth/login/login.component';
import { PagesComponent } from '.././app/pages/pages.component';
//import {LoginComponent} from '.././app/auth/login/login.component'
const routes: Routes = [
  /*{
    path: 'login',
    loadChildren: () => import('./auth/login/login.module')
      .then(m => m.LoginModule),
  },*/
  
  {
    path: 'pages',
    loadChildren: () => import('./pages/pages.module')
      .then(m => m.PagesModule),
  },
  { path: '', redirectTo: 'pages', pathMatch: 'full' },
  { path: '**', redirectTo: 'pages' },
];

const config: ExtraOptions = {
  useHash: false,
};

@NgModule({
  imports: [ RouterModule.forRoot(routes, config)],
  exports: [RouterModule],
})
export class AppRoutingModule {
}
